<template>
    <Page :header="header[lang_].title" type="gray">
        <template v-slot:body>
            <Senders v-if="!loading && list && list.length>=0"
                :list="list" :loading="loading" :total="total" :rows="rows" :skip="skip"
                @update:first="updateSkip"/>
            <Skeleton v-if="loading" height="2rem" class="mb-3" /> 
        </template>
    </Page>
</template>
  
<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Senders from '@/components/personal/profile/sender_list.vue'
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            header: {
                en: {title: "My senders"} ,
                ru: {title: "Мои отправители"} ,
            }, 
            list: [],
            loading: false,
            total: 0,
            rows: 10,
            skip: 0,
        }
    },
    components: {
        Page,
        Senders
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        updateSkip(val){
            this.skip = val
            this.loadSenders()
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity, summary, detail, life: 5000});
        },
        async loadSenders(){
            this.loading = true
            try {
                const res = await this.connect.GetPersonalSenders(this.rows, this.skip).then(res => res)
                if (res.result) {
                    this.list = res.data
                    this.total = res.total
                } else {
                    if(res.message) this.showMess('error', 'Error', res.message)
                    else this.showMess('error', 'Error', 'Failed to load senders')
                }
            } catch (e) {
                this.showMess('error', 'Error', e.message)
                console.error(e)
            }
            this.loading = false
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
        this.loadSenders()
    }
}
</script>